<div class="container m-t-10 m-b-8" id="github-details">
    <div class="header d-flex align-items-center justify-content-between">
        <div class="header-text">
            <h4>{{title}}</h4>
        </div>
        <button class="close-icon d-flex align-items-center justify-content-center" type="button"
            (click)="closeDialog()" aria-label="Close">
            <span aria-hidden="true" style="font-size: 32px; line-height: 1;">&times;</span>
        </button>
    </div>
    <hr class="my-3" style="border-top: 1px solid #dee2e6;">
    <!-- Scrollable Popup Content -->
    <div class="scrollbar scrollable-content custom-scroll">
        <div *ngIf="serviceDto; else noData">
            <dl class="row mb-0">
                <dt class="col-sm-12 text-secondary">GitHub Repository Name:</dt>
                <dd class="col-sm-12 text-dark m-b-20">{{ serviceDto.gitHubRepositoryName }}</dd>

                <dt class="col-sm-12 text-secondary">GitHub Default Branch:</dt>
                <dd class="col-sm-12 text-dark m-b-20">{{ serviceDto.gitHubDefaultBranchName }}</dd>
            </dl>
        </div>
        <ng-template #noData>
            <div class="text-center m-t-20 m-b-20">
                No Data Found
            </div>
        </ng-template>
    </div>
</div>